import { StoreActions } from '.';

export function setNavigationPath(path) {
  return {
    type: StoreActions.SET_REDIRECT_PATH,
    path,
  };
}
